import { Permission, SalesOrderDTO } from 'core/api';
import { Command } from 'pos/common';
import { Preconditions } from 'core/infrastructure-next';
import { sendDocumentEmail } from 'pos/modules/helpers/document-emailing';
import { SalesOrderFacade } from 'pos/facades';

declare global {
	interface CommandType {
		sendSalesOrderEmail: (salesOrder: SalesOrderDTO) => Promise<Result>
	}
}

Command.register('sendSalesOrderEmail', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_SendEmail), Preconditions.ensureIsNotLite), async (salesOrder: SalesOrderDTO): Promise<Result> => {
	const options = await SalesOrderFacade.getEmailOptions(salesOrder.Id);
	return sendDocumentEmail({
		getDefaultOptions: () => options,
		send: SalesOrderFacade.sendEmail
	});
});